import { useCallback, useEffect, useState } from "react";
import "../leaveHistory.css";
import DashboardGreeting from "../DashboardGreeting";
import { useStateContext } from "../../contexts/ContextProvider";
import FilterIcon from "../../assets/images/filter.svg";
import ApplyLeaveIcon from "../../assets/images/applyLeaveIcon.svg";
import ViewIcon from "../../assets/images/view.svg";
import EditIcon from "../../assets/images/edit.svg";
import DeleteIcon from "../../assets/images/delete.svg";
import DashedArrow from "../../assets/images/dashed-arrow.svg";
import PartiallyApprovedDashedArrow from "../../assets/images/partiallyApprovedDashedArrow.svg";
import ApprovedDashedArrow from "../../assets/images/approvedDashedArrow.svg";
import partiallyRejectedDashedArrow from "../../assets/images/partiallyRejectedDashedArrow.svg";
import RejectedDashedArrow from "../../assets/images/rejectedDashedArrow.svg";
import GreenCheck from "../../assets/images/greenCheck.svg";
import RedCross from "../../assets/images/close-circle.svg";
import moment from "moment";
import DataTableComponent from "../Charts/DatatableComponent";
import "./employee.css";
import TimeIcon from "../../assets/images/time.svg";

import { Link } from "react-router-dom";
import ApplyLeave from "./ApplyLeave";
import EditLeave from "./EditLeave";
import DeleteLeave from "./DeleteLeave";
import LeaveHistoryFilterModal from "../common/LeaveHistoryFilterModal";
import AuthService from "../../services/auth.service";
import LeaveHistoryService from "../../services/leaveHistory.service";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import Success from "../common/CustomModals/Success";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Empty, Skeleton } from "antd";

const LeaveApplicationAction = ({
  setEditLeaveModal,
  setSelectedData,
  setDeleteLeaveModal,
  rowData,
  leaveCat,
}) => {
  return (
    <div className="d-flex gap-2">
      <Link
        to={"/leaveDetails"}
        state={{
          rowData: rowData,
          leaveCat: leaveCat,
          redirectBack: "/leaveHistory",
        }}
      >
        <span>
          <img src={ViewIcon} alt="" />
        </span>
      </Link>

      {rowData.rmActionsts === "0" && (
        <>
          <span>
            <img
              src={EditIcon}
              onClick={(e) => {
                setEditLeaveModal(true);
                setSelectedData(rowData);
              }}
              alt=""
            />
          </span>

          <span>
            <img
              src={DeleteIcon}
              onClick={(e) => {
                setDeleteLeaveModal(true);
                setSelectedData(rowData);
              }}
              alt=""
            />
          </span>
        </>
      )}
    </div>
  );
};

const LeaveHistory = () => {
  const user = AuthService.getCurrentUser();
  const navHeading = "Leave History";

  const {
    filterBy,
    setFilterBy,
    applyLeaveModal,
    setApplyLeaveModal,
    editLeaveModal,
    setEditLeaveModal,
    deleteLeaveModal,
    setDeleteLeaveModal,
    applyWorkModeModal,
    setApplyWorkModeModal,
    success,
    setSuccess,
  } = useStateContext();

  const initialData = {
    leaveReason: "",
    date: "",
    formatedDate: "",
    status: "",
  };

  const currentDate = new Date();
  const maxDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );

  const [heading, setHeading] = useState("");

  const [details, setDetails] = useState(initialData);
  const [checked, setChecked] = useState("");

  const [leaveCat, setLeaveCat] = useState([]);

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const [appliedOn, setAppliedOn] = useState();

  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [selectedData, setSelectedData] = useState({});

  const fetchLeaveTypes = useCallback(() => {
    LeaveHistoryService.getLeaveCategory()
      .then((response) => {
        if (response.data) {
          const x = response.data.map((item) => ({
            label: item.catname,
            value: item.catid,
          }));
          setLeaveCat(x);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchLeaveTypes();
  }, [fetchLeaveTypes]);

  const showFilter = (e) => {
    e.preventDefault();
    setFilterBy(true);
  };

  const showApplyLeave = (e) => {
    e.preventDefault();
    setApplyLeaveModal(true);
  };

  const fetchData = useCallback(() => {
    const payload = {
      emp_id: user.empid,
    };

    setLoading(true);

    LeaveHistoryService.getLeaveRequest(payload)
      .then((response) => {
        if (response.data) {
          setLoading(false);
          setData(response.data);
        }
      })
     .catch((e) => {
         console.log(e);
         setData([]);
      });
  }, [user.empid]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      name: "Leave Reason",
      selector: (row) => row.leaveReason,
      cell: (row) => (
        <>
          <div className="emp-info">
            <div className="flex-column">
              <span>{row.leaveReason}</span>
            </div>
            <div className="leave-details">
              <div className="profiles">
                <div className="profile">
                  <span className="name">{row.managerName}</span>
                  <span className="desig">TL</span>
                </div>

                <div className="icon flex-row gap-2">
                  {row.rmActionsts === "0" ? (
                    <>
                      <span>
                        <img src={TimeIcon} alt="" />
                      </span>
                    </>
                  ) : row.rmActionsts === "1" ? (
                    <>
                      <span>
                        <img src={GreenCheck} alt="" />
                      </span>
                    </>
                  ) : row.rmActionsts === "2" ? (
                    <>
                      <span>
                        <img src={RedCross} width={20} alt="" />
                      </span>
                    </>
                  ) : null}

                  {user.role !== "1" && (
                    <>
                      {" "}
                      {row.rmActionsts === "0" && row.hrActionsts === "0" ? (
                        <>
                          <span className="">
                            <img src={DashedArrow} width={125} alt="" />
                          </span>
                        </>
                      ) : row.rmActionsts === "1" && row.hrActionsts === "0" ? (
                        <>
                          <div className="process-flex">
                            <span className="">
                              <img
                                src={PartiallyApprovedDashedArrow}
                                width={125}
                                alt=""
                              />
                            </span>
                          </div>
                        </>
                      ) : row.rmActionsts === "1" || row.hrActionsts === "1" ? (
                        <>
                          <span className="">
                            <img src={ApprovedDashedArrow} width={125} alt="" />
                          </span>
                        </>
                      ) : row.rmActionsts === "2" ? (
                        <>
                          <span>
                            <img
                              src={partiallyRejectedDashedArrow}
                              width={125}
                              alt=""
                            />
                          </span>
                        </>
                      ) : row.hrActionsts === "2" ? (
                        <>
                          <span>
                            <img src={RejectedDashedArrow} width={125} alt="" />
                          </span>
                        </>
                      ) : null}
                      {row.hrActionsts === "0" ? (
                        <>
                          <span>
                            <img src={TimeIcon} alt="" />
                          </span>
                        </>
                      ) : row.hrActionsts === "1" ? (
                        <>
                          <span>
                            <img src={GreenCheck} alt="" />
                          </span>
                        </>
                      ) : row.hrActionsts === "2" ? (
                        <>
                          <span>
                            <img src={RedCross} alt="" />
                          </span>
                        </>
                      ) : null}
                    </>
                  )}
                </div>
                {user.role !== "1" && (
                  <div className="profile">
                    <span className="name">Sapna Sonwani</span>
                    <span className="desig">HR</span>
                  </div>
                )}
              </div>
              {user.role !== "2" && row.rmActionsts !== "0" ? (
                <>
                  <div className="profiles">
                    <div className="profile">
                      <span className="name">
                        {row.rmActionsts === "1"
                          ? "Approved By RM"
                          : row.rmActionsts === "2"
                            ? "Rejected By RM"
                            : ""}
                      </span>
                      <span className="desig">{row.rmActionOn}</span>
                    </div>
                  </div>
                </>
              ) : null}
              {row.hrActionsts !== "0" ? (
                <>
                  <div className="profiles">
                    <div className="profile">
                      <span className="name">
                        {row.hrActionsts === "1"
                          ? "Approved By HR"
                          : row.hrActionsts === "2"
                            ? "Rejected By HR"
                            : ""}
                      </span>
                      <span className="desig">{row.hrActionOn}</span>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </>
      ),
      sortable: true,
      // width: "200px",
    },
    {
      name: "From",
      selector: (row) => row.fromDate,
      cell: (row) => (
        <>
          <span>{row.fromDate}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "To",
      selector: (row) => row.toDate,
      cell: (row) => (
        <>
          <span>{row.toDate}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Applied On",
      selector: (row) => row.requstOn,
      cell: (row) => (
        <>
          <span>{row.requstOn}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Duration",
      selector: (row) => row.leavedays,
      cell: (row) => (
        <>
          <span title={`${row.leavedays}`}>{`${row.leavedays}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "DOR",
      selector: (row) => row.dor,
      cell: (row) => (
        <>
          <span title={`${row.dor}`}>{`${row.dor}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "RM Approval",
      selector: (row) => row.rmActionsts,
      cell: (row) => (
        <>
          <div
            className={`${
              row.rmActionsts === "0"
                ? "status pending"
                : row.rmActionsts === "1"
                  ? "status approved"
                  : "status rejected"
            }`}
          >
            <span
              title={`${
                row.rmActionsts === "0"
                  ? "Pending"
                  : row.rmActionsts === "1"
                    ? "Approved"
                    : "Rejected"
              }`}
            >{`${
              row.rmActionsts === "0"
                ? "Pending"
                : row.rmActionsts === "1"
                  ? "Approved"
                  : "Rejected"
            }`}</span>
          </div>
        </>
      ),
      sortable: true,
      omit: user.role === "2",
    },
    {
      name: "HR Approval",
      selector: (row) => row.hrActionsts,
      cell: (row) => (
        <>
          <div
            className={`${
              row.hrActionsts === "0"
                ? "status pending"
                : row.hrActionsts === "1"
                  ? "status approved"
                  : "status rejected"
            }`}
          >
            <span
              title={`${
                row.hrActionsts === "0"
                  ? "Pending"
                  : row.hrActionsts === "1"
                    ? "Approved"
                    : "Rejected"
              }`}
            >{`${
              row.hrActionsts === "0"
                ? "Pending"
                : row.hrActionsts === "1"
                  ? "Approved"
                  : "Rejected"
            }`}</span>
          </div>
        </>
      ),
      sortable: true,
      omit: user.role === "1",
    },
    {
      name: "Action",
      selector: (row) => row.actionStatusHR,
      cell: (row) => (
        <>
          <LeaveApplicationAction
            setEditLeaveModal={setEditLeaveModal}
            setDeleteLeaveModal={setDeleteLeaveModal}
            setSelectedData={setSelectedData}
            rowData={row}
            leaveCat={leaveCat}
          />
        </>
      ),
      sortable: true,
    },
  ];

  const [date, setDate] = useState("");

  const handleDateChange = (e) => {
    setDate(e.value);
    if (!e.value) {
      setFilter(false);
      return;
    }
    filterDataMonthWise(e.value);
  };

  const filterDataMonthWise = (value) => {
    const selectedYear = moment(new Date(value)).format("YYYY");
    const selectedMonth = moment(new Date(value)).format("M");

    // pick the correct dataset based on tab

    // console.log(selectedYear, selectedMonth);

    const filtered = data.filter((item) => {
      if (!item || !item.requstOn) return false;

      // Try parsing requestOn with moment. Accept multiple formats.
      let m = moment(item.requstOn, "DD-MM-YYYY");
      // console.log("m", m.format("YYYY"), m.format("M"));
      if (!m.isValid()) {
        // fallback to Date parse then moment
        m = moment(new Date(item.requstOn));
      }
      if (!m.isValid()) return false;

      return (
        m.format("YYYY") === selectedYear && m.format("M") === selectedMonth
      );
    });

    // console.log(filtered);

    setFilter(true);
    setFilteredData(filtered);
  };

  const handleCheckedChange = (type) => (e) => {
    if (e.target.checked) {
      setChecked(type);
    } else {
      setChecked("");
    }
  };

  const handleFilter = () => {
    let filteredData = data;

    const objectValues = {
      leaveReason: details.leaveReason,
      requstOn: details.date,
      hrActionsts: checked,
      rmActionsts: checked,
    };

    const nonEmptyDetails = Object.fromEntries(
      Object.entries(objectValues).filter(
        ([_, value]) => value !== "" && value !== null,
      ),
    );

    filteredData = filteredData.filter((item) =>
      Object.entries(nonEmptyDetails).every(([detailsKey, value]) =>
        checked !== ""
          ? item.hrActionsts === checked ||
            item.rmActionsts === checked ||
            item[detailsKey] === value
          : item[detailsKey] === value,
      ),
    );

    setFilter(true);
    setFilteredData(filteredData);
    setFilterBy(false);
  };

  const clearFilter = () => {
    setFilter(false);
    setDetails(initialData);
    setChecked("");
    setAppliedOn();
    setFilterBy(false);
  };

  const deleteLeave = () => {
    const payload = {
      rid: selectedData.rid,
    };

    LeaveHistoryService.deleteleaveRequest(payload)
      .then((resp) => {
        if (resp.data) {
          fetchData();

          toast.success("Leave Application Deleted Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => {
              setDeleteLeaveModal(false);
            },
          });
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div className="dashboard-container leave-history">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <ToastContainer />
        <div className="filterBar mb-3">
          <div className="filter">
            <div className="new-calendar-type flex justify-content-center">
              <Calendar
                value={date}
                onChange={handleDateChange}
                view="month"
                placeholder="Select Month"
                dateFormat="M, yy"
                style={{ height: "100%" }}
                showIcon
                maxDate={maxDate}
                showButtonBar
                selectOtherMonths
              />
            </div>
          </div>
          <div className="sort-filter filter">
            <div className="filter" onClick={showFilter}>
              <img src={FilterIcon} alt="" />
            </div>
          </div>
          <div className="action">
            <button className="apply" onClick={showApplyLeave}>
              <span>
                <img src={ApplyLeaveIcon} alt="" />
              </span>
              <span>Apply Leave</span>
            </button>
          </div>
        </div>
        {loading ? (
          <>
            <Skeleton active={loading} />
          </>
        ) : (filter ? filteredData : data).length === 0 ? (
          <>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </>
        ) : (
          <>
            <DataTableComponent
              columns={columns}
              data={filter ? filteredData : data}
            />
          </>
        )}

        <div
          className={`${editLeaveModal ? "modal-overlay" : ""}`}
          onClick={() => {
            setEditLeaveModal(false);
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          ></div>
        </div>

        <div
          className={`${
            editLeaveModal
              ? "applyLeaveModal visible"
              : "applyLeaveModal hidden"
          }`}
        >
          <EditLeave
            selectedData={selectedData}
            setSuccess={setSuccess}
            leaveCat={leaveCat}
            fetchData={fetchData}
            setHeading={setHeading}
          />
        </div>

        <div
          className={`${filterBy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setFilterBy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <LeaveHistoryFilterModal
              leaveCat={leaveCat}
              details={details}
              setDetails={setDetails}
              checked={checked}
              handleCheckedChange={handleCheckedChange}
              handleFilter={handleFilter}
              clearFilter={clearFilter}
              appliedOn={appliedOn}
              setAppliedOn={setAppliedOn}
            />
          </div>
        </div>

        <div
          className={`${applyLeaveModal ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setApplyLeaveModal(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <ApplyLeave
              setSuccess={setSuccess}
              leaveCat={leaveCat}
              fetchData={fetchData}
              setHeading={setHeading}
            />
          </div>

          <div
            className={`${
              success ? "modal-overlay success-modal-overlay" : ""
            }`}
            onClick={() => {
              setSuccess(false);
            }}
          >
            <div onClick={(e) => e.stopPropagation()}>
              <Success
                heading={heading}
                para="You can check your leave status on ‘Leave History‘ page."
                redirect="/leaveHistory"
              />
            </div>
          </div>
        </div>

        <div
          className={`${deleteLeaveModal ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setDeleteLeaveModal(false);
          }}
        >
          <div className="" onClick={(e) => e.stopPropagation()}>
            <DeleteLeave deleteLeave={deleteLeave} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveHistory;
